import { useState } from "react";

import { flattenConversations, useConversations } from "~/ai-chat/data-source/use-conversations";
import { useAiChat } from "~/ai-chat/feature/use-ai-chat";

// Save + share controls shared by the floating widget and the full-page chat. Share opens one
// `ChatShareModal` that classifies + shares in a single surface; Save opens the plain save-to-library dialog.
//
// `shareInitialResourceId` is the resource this chat is already saved as (so the share modal opens straight
// to the sharing view): the save-session memory first (reliable right after a save), then the backend
// conversation link from the list cache (covers a reload). Null ⇒ the share modal classifies + saves first.
export function useChatSaveShare() {
  const { activeConversationId, savedTranscriptResourceId } = useAiChat();
  const conversations = useConversations();
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);

  const linkedFromCache =
    activeConversationId === null
      ? null
      : (flattenConversations(conversations.data).find((conversation) => conversation.id === activeConversationId)
          ?.transcriptResourceId ?? null);

  return {
    saveDialogOpen,
    openSaveDialog: () => setSaveDialogOpen(true),
    closeSaveDialog: () => setSaveDialogOpen(false),
    shareModalOpen,
    shareInitialResourceId: savedTranscriptResourceId ?? linkedFromCache,
    openShareModal: () => setShareModalOpen(true),
    closeShareModal: () => setShareModalOpen(false),
  };
}
